import ReactDOM from "react-dom/client"

import store from "./store/store"
import { Provider } from "react-redux"

import App from "./App"

import * as serviceWorker from "./serviceWorker"

import { createTheme, StyledEngineProvider, ThemeProvider } from "@mui/material/styles"

import { BrowserRouter } from "react-router-dom"

import "@fontsource-variable/inter"
import "./index.css"

const theme = createTheme({
  typography: {
    fontFamily: "'Inter Variable', Inter, Roboto, sans-serif"
  },
  spacing: 8,
  palette: {
    primary: {
      light: "#337799",
      main: "#005680",
      dark: "#004466",
      contrastText: "#FFFFFF"
    },
    secondary: {
      light: "#7b9eb3",
      main: "#5A86A1",
      dark: "#486b80",
      contrastText: "#FFFFFF"
    }
  },
  components: {
    MuiInputBase: {
      styleOverrides: {
        root: {
          "&.Mui-disabled": {
            background: "#eeeeee"
          }
        }
      }
    },
    MuiAccordion: {
      styleOverrides: {
        root: {
          borderRadius: 4,
          margin: "8px 0 0 0",
          "&:before": {
            display: "none"
          },
          "&:first-of-type": {
            marginTop: 0
          },
          "&.Mui-expanded": {
            margin: "8px 0 0 0"
          }
        }
      }
    },
    MuiAccordionSummary: {
      styleOverrides: {
        root: {
          // padding: "0 8px",
          minHeight: 48,
          height: 48,
          // "&.Mui-expanded": {
          //   minHeight: 48,
          //   height: 48
          // }
        },
        content: {
          margin: "auto 0 !important",
          alignItems: "center"
        },
        expandIconWrapper: {
          padding: 4,
          margin: "0 -8px 0 0"
        }
      }
    },
    MuiAccordionDetails: {
      styleOverrides: {
        root: {
          display: "flex",
          flexDirection: "column",
          padding: "0 8px 8px"
        }
      }
    },
    MuiDialogContent: {
      styleOverrides: {
        root: {
          display: "flex",
          flexDirection: "column",
          maxHeight: "100%",
          boxSizing: "border-box"
        }
      }
    },
    MuiButton: {
      styleOverrides: {
        root: {
          boxShadow: "0px 2px 1px -1px rgba(0,0,0,0.2),0px 1px 1px 0px rgba(0,0,0,0.14),0px 1px 3px 0px rgba(0,0,0,0.12)",
          textTransform: "unset",
          "&:active": {
            boxShadow: "0px 3px 5px -1px rgba(0,0,0,0.2),0px 6px 10px 0px rgba(0,0,0,0.14),0px 1px 18px 0px rgba(0,0,0,0.12)"
          }
        },
        disableElevation: {
          boxShadow: "unset",
          "&:active": {
            boxShadow: "unset"
          }
        }
      }
    },
    MuiFab: {
      styleOverrides: {
        root: {
          boxShadow: "0px 2px 1px -1px rgba(0,0,0,0.2),0px 1px 1px 0px rgba(0,0,0,0.14),0px 1px 3px 0px rgba(0,0,0,0.12)",
          textTransform: "unset",
          "&:active": {
            boxShadow: "0px 3px 5px -1px rgba(0,0,0,0.2),0px 6px 10px 0px rgba(0,0,0,0.14),0px 1px 18px 0px rgba(0,0,0,0.12)"
          }
        }
      }
    },
    MuiSlider: {
      styleOverrides: {
        thumb: {
          "&:hover, &.Mui-focusVisible": {
            boxShadow: "0 0 0 6px rgba(0,124,192,0.16)"
          },
          "&.Mui-active": {
            boxShadow: "0 0 0 8px rgba(0,124,192,0.16)"
          }
        }
      }
    },
    MuiMenuItem: {
      styleOverrides: {
        root: {
          "&.Mui-selected": {
            backgroundColor: "rgba(0, 0, 0, 0.08)",
            "&:hover": { backgroundColor: "rgba(0, 0, 0, 0.08)" },
            "&.Mui-focusVisible": { background: "rgba(0, 0, 0, 0.08)" }
          }
        }
      }
    },
    MuiButtonBase: {
      defaultProps: {
        disableRipple: true
      }
    },
    MuiCheckbox: {
      defaultProps: {
        disableFocusRipple: true,
        disableTouchRipple: true,
        disableRipple: true
      }
    },
    MuiTooltip: {
      defaultProps: {
        disableInteractive: true
      }
    }
  }
})

const root = ReactDOM.createRoot(document.getElementById("root"))

root.render(
  <Provider store={store}>
    <StyledEngineProvider injectFirst>
      <ThemeProvider theme={theme}>
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </ThemeProvider>
    </StyledEngineProvider>
  </Provider>
)

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister()
